import React, { useEffect } from "react";
import { useForm, useWatch, Controller } from "react-hook-form";
import { Box, Grid } from "@mui/material";
import { isValid, isBefore } from "date-fns";
import moment from "moment-timezone";
import { getUTCDateWithLocalTimezone, parseDateIntoUTC, formatDate, checkDateStringSatisfiesMask } from "../../utils/date.js";
import "react-intl";
import { DateInputMask } from "./DatePicker.config.js";
import { localizedDatePickerFooterRangeMode } from "./DatePickerFooterRangeMode.localize.js";
import { useDatePickerFooterRangeModeClasses } from "./DatePickerFooterRangeMode.style.js";
import { FormTextInputDefault } from "./FormInput.js";
const DatePickerFooterRangeMode = ({ value, locale, onChange }) => {
  const { classes } = useDatePickerFooterRangeModeClasses();
  const inputMask = DateInputMask[locale] ?? "YYYY-MM-DD";
  const { control, setValue } = useForm({ defaultValues: { from: "", to: "" } });
  const watched = useWatch({ control });
  const parsedFrom = getUTCDateWithLocalTimezone(moment(parseDateIntoUTC(watched.from, inputMask)));
  const parsedTo = getUTCDateWithLocalTimezone(moment(parseDateIntoUTC(watched.to, inputMask)));
  useEffect(() => {
    if (value?.from?.getTime() !== parsedFrom?.getTime()) {
      setValue("from", isValid(value?.from) ? formatDate(value?.from, "iso-date", false, false) : "");
    }
    if (value?.to?.getTime() !== parsedTo?.getTime()) {
      setValue("to", isValid(value?.to) ? formatDate(value?.to, "iso-date", false, false) : "");
    }
  }, [value]);
  useEffect(() => {
    if (checkDateStringSatisfiesMask(watched.from, inputMask) && checkDateStringSatisfiesMask(watched.to, inputMask) && isValid(parsedFrom) && isValid(parsedTo) && isBefore(parsedFrom, parsedTo)) {
      onChange({ from: parsedFrom, to: parsedTo });
    }
  }, [watched.from, watched.to]);
  return /* @__PURE__ */ React.createElement(Box, { mt: 2 }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 1 }, /* @__PURE__ */ React.createElement(Grid, { size: { xs: 6, md: 6 } }, /* @__PURE__ */ React.createElement(
    Controller,
    {
      render: ({ field, fieldState }) => /* @__PURE__ */ React.createElement(
        FormTextInputDefault,
        {
          className: classes.datePickerFooterRangeModeInput,
          key: field.name,
          value: field.value,
          onChange: field.onChange,
          fieldState,
          placeholder: inputMask,
          label: localizedDatePickerFooterRangeMode.datePickerFooterRangeModeFromLabel
        }
      ),
      name: "from",
      control
    }
  )), /* @__PURE__ */ React.createElement(Grid, { size: { xs: 6, md: 6 } }, /* @__PURE__ */ React.createElement(
    Controller,
    {
      render: ({ field, fieldState }) => /* @__PURE__ */ React.createElement(
        FormTextInputDefault,
        {
          className: classes.datePickerFooterRangeModeInput,
          key: field.name,
          value: field.value,
          onChange: field.onChange,
          fieldState,
          placeholder: inputMask,
          label: localizedDatePickerFooterRangeMode.datePickerFooterRangeModeToLabel
        }
      ),
      name: "to",
      control
    }
  ))));
};
export {
  DatePickerFooterRangeMode
};
//# sourceMappingURL=DatePickerFooterRangeMode.js.map
